<div class="titlebar">
    <h1>
        <span #titulo><ng-content select="titlebar-titulo"></ng-content></span>
        <ng-template [ngIf]="titulo.children.length == 0">-Título por defecto-</ng-template>
        <small class="subtitle"><ng-content select="titlebar-subtitulo"></ng-content></small>
    </h1>
</div>
